/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { CmsProduct } from '../../types/cmsProduct';
import SeedlyIcon from '../icons/SeedlyIcon';
import StarIcon from '../icons/StarIcon';
import Tooltip from '../Tooltip';

type RatingComponentProps = CmsProduct & {
  mode?: ModeRating;
  max?: string | number;
};

export const RatingComponent: React.FC<RatingComponentProps> = ({
  mode = ModeRating.HORIZONTAL,
  rate_additional_information,
  rate_score,
  rate_label,
  max = 5,
}) => {
  const ratingClass = classNames(
    'mt-5 flex items-center gap-gap/y-xs text-base md:text-xl',
    {
      '!items-start': mode === 'vertical',
    },
  );

  const subsectionClass = classNames(
    'flex items-center gap-gap/y-xs text-base md:text-xl',
    { 'flex-col !items-start': mode === 'vertical' },
  );

  return (
    <div className={ratingClass}>
      <div className={subsectionClass}>
        <div className="flex items-center gap-gap/y-xs">
          <div className="whitespace-nowrap text-gray-800 alpha-body-1">
            <SeedlyIcon /> {rate_label}
          </div>
        </div>
        <div className="flex items-center gap-gap/y-xs">
          <StarIcon />
          <div className="text-brand-primary-dark alpha-subheading-2">
            <span className="mhg-alpha-subheading-2 text-[#2955DE]">
              {rate_score}
            </span>
          </div>
          <div className="text-gray-700 alpha-body-1">/ {max}</div>
        </div>
      </div>
      {rate_additional_information && (
        <Tooltip content={rate_additional_information}></Tooltip>
      )}
    </div>
  );
};

export enum ModeRating {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
